
import { useAuthContext } from '@/features/auth/context'
import { NotifyService } from '@/helpers'
import { usePermission } from '@/hooks/permissions'
import useTranslation from '@/hooks/useTranslation'
import {
  Stack,
  TableCell,
  TableRow,
  TableRowProps,
  Typography,
} from '@mui/material'
import { useConfigUI } from '../../../context'
import { ITurfQuality } from '@/api/config/turfQualityApi'

interface IProps extends TableRowProps {
  expandedParent?: boolean
  row: ITurfQuality
  handleDeleteItem: (id: number | string, interfaceId: string) => void
}

const TurfQualityTableRow = (props: IProps) => {
  const { t } = useTranslation()
  const { expandedParent, row, handleDeleteItem, ...trProps } = props

  const { openSidebar, setSidebarView } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const { isViewOnly } = usePermission()

  const handleEdit = (id: string | number) => {
    // ViewOnly users cannot edit 
    if (isViewOnly) return

    openSidebar()
    setSidebarView({
      type: 'TURFQUALITY_VIEW',
      id: String(id),
    })
  }

  return (
    <TableRow {...trProps}>
      <TableCell sx={{ borderRight: '1px solid #d7d7d7' }}>
        {row.id}
        </TableCell>
      <TableCell sx={{ borderRight: '1px solid #d7d7d7' }}>
        {row.name}
      </TableCell>
      <TableCell sx={{ borderRight: '1px solid #d7d7d7' }}>
        {row.irrigationFactor}
      </TableCell>
      <TableCell sx={{ borderRight: '1px solid #d7d7d7' }}>
        {row.calculatedWaterBudget}
      </TableCell>

      <TableCell>
        <Stack direction="row" spacing="20px">
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: '500',
              lineHeight: '100%',
              color: isViewOnly ? 'black' : 'primary.main',
              cursor: isViewOnly ? 'not-allowed' : 'pointer',
              opacity: isViewOnly ? 0.2 : 1,
            }}
            onClick={() => {
              handleEdit(row.id)
            }}
          >
            {t('actionEdit')}
          </Typography>

          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: '500',
              lineHeight: '100%',
              color: isViewOnly ? 'black' : 'grey.600',
              cursor: isViewOnly ? 'not-allowed' : 'pointer',
              opacity: isViewOnly ? 0.2 : 1,
            }}
            onClick={() => {
              handleDeleteItem(row.id, interfaceId+"")
            }}
          >
            {t('actionDelete')}
          </Typography>
        </Stack>
      </TableCell>
    </TableRow>
  )
}

export default TurfQualityTableRow
